import React, {useState, VoidFunctionComponent} from "react";
import {pluralize} from "@/utils/responsive/utils";
import {Question} from "@/models/scope/productSheet/questions/Question";
import {Answer} from "@/models/scope/productSheet/questions/Answer";

export const QuestionAnswerBlock: VoidFunctionComponent<{ question: Question }> = ({question}) => {

    const {firstname, content, date, answersList} = question;
    const [displayMoreAnswers, setDisplayMoreAnswers] = useState(false);


    const renderAnswers = (answer: Answer, index: number) => {
        const {firstname, content, date, answerId} = answer;
        if (index < 1 || displayMoreAnswers)
            return (
                <div className='answer-container' key={answerId}>
                    <div className='answer-block'>
                        <div className='triangle'/>
                        <p className='pseudo'>{firstname}</p>
                        <p className='date'>{date}</p>
                        <p className='answer-text'>{content}</p>
                    </div>
                </div>
            );
    };
    return (
        <div className='question-answer-block'>
            <div className='question-block'>
                <p className='pseudo'>{firstname}</p>
                <p className='date'>{date}</p>
                <p className='question-text'>{content}</p>
            </div>
            {answersList?.map((answer, index) => renderAnswers(answer, index))}
            {answersList.length > 1 && !displayMoreAnswers && (
                <p className='more-answers' onClick={() => setDisplayMoreAnswers(true)}>
                    {answersList.length - 1}{' '}
                    {pluralize(answersList.length - 1, 'autre')}{' '}
                    {pluralize(answersList.length - 1, 'réponse')}
                </p>
            )}
        </div>
    );
};